import React from 'react'

export const ProfileCard=({profile})=>{

    return <div className='profile-container'>
        <Image/>
        <ProfileContent {...profile}/>
    </div>
}

const Image=()=>{
    return <div className='image-container'>
        <img alt='Profile' className='profile-image' src='/profile.jpg'/>
    </div>

}
const ProfileContent=(profile)=>{
    return <div className='profile-content'>
        <div className='profile-header'>{profile.firstName} {profile.lastName}</div>
        <div className='profile-subheading'>{profile.organisation}</div>
        <div className='profile-body'>{profile.designation}</div>
    </div>
}